export default "__VITE_ASSET__53q16$f4__"